import { render, staticRenderFns } from "./MotorClaimPosted.vue?vue&type=template&id=6fcb929b&"
import script from "./MotorClaimPosted.vue?vue&type=script&lang=js&"
export * from "./MotorClaimPosted.vue?vue&type=script&lang=js&"
import style0 from "./MotorClaimPosted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorClaimPosted.vue"
export default component.exports